import useIntersection from '../../../assets/hooks/useIntersection';
import './Bennefits.css';
import { BennefitsArrows, BennefitsBackBraclet, BennefitsBase, BennefitsBottomBraclet, BennefitsButtons, BennefitsDial, BennefitsFrontBracelet, BennefitsFrontBtn, BennefitsMechanism, BennefitsSmallDials } from './BennefitsIcons';

const CARDS = [
    {
        title: 'Sell Your Watch Fast',
        text: `Sell your luxury watch quickly and easily. Get instant evaluation, top market price, and same-day cash. Just send your watch details&nbsp;&mdash; we&rsquo;ll handle the rest`,
    },
    {
        title: 'Source Any Watch',
        text: `At&nbsp;the client&rsquo;s request, we&nbsp;can select and source any model of&nbsp;premium watches`,
    },
    {
        title: 'Best Prices',
        text: `We&nbsp;offer top prices for Swiss watches, bags, and jewelry. Backed by&nbsp;market expertise and a&nbsp;global network, we&nbsp;guarantee fair, competitive deals`,
    },
    {
        title: 'Fast Worldwide Delivery',
        text: `Fast, reliable global shipping. Wherever you are, your luxury item will arrive safely and quickly`,
    },
    {
        title: 'Sell on&nbsp;Consignment',
        text: `Want to&nbsp;sell without the rush? Use&nbsp;our&nbsp;consignment service. We&nbsp;manage everything&mdash;listing, marketing, and sales&mdash;so you earn more with zero stress`,
    },
]
function Bennefits() {
    const [bennefitsRef, isVisible] = useIntersection({ threshold: 0.6 });

    return (
        <div
            className={`bennefits ${isVisible ? 'bennefits--animate' : ''}`}
            ref={bennefitsRef}
        >
            <p className="bennefits__title">Our advantages</p>
            <div className='bennefits__content'>
                <div className='bennefits__cards'>
                    {CARDS.map((item, i) => (
                        <div className='bennefits__card' key={`bennefits__card${i}`}>
                            <p className='bennefits__card-title' dangerouslySetInnerHTML={{ __html: item.title }}></p>
                            <p className='bennefits__card-text' dangerouslySetInnerHTML={{
                                __html: item.text
                            }}></p>
                        </div>
                    ))}
                </div>
                <div className='bennefits__image'>
                    <BennefitsArrows mainClassName={'bennefits__arrows'} />
                    <BennefitsSmallDials mainClassName={'bennefits__small-dials'} />
                    <BennefitsDial mainClassName={'bennefits__dial'} />
                    <BennefitsBase mainClassName={'bennefits__base'} />
                    <BennefitsFrontBtn mainClassName={'bennefits__front-btn'} />
                    <BennefitsFrontBracelet mainClassName={'bennefits__front-bracelet'} />
                    <BennefitsMechanism mainClassName={'bennefits__mechanism'} />
                    <BennefitsButtons mainClassName={'bennefits__buttons'} />
                    <BennefitsBackBraclet mainClassName={'bennefits__back-bracelet'} />
                    <BennefitsBottomBraclet mainClassName={'bennefits__bottom-bracelet'} />
                </div>
            </div>
        </div>
    );
}

export default Bennefits